import { Component, inject } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { Sort, MatSortModule } from '@angular/material/sort';
import { AppState } from 'src/app/app.state';
import { LoadingSpinnerComponent } from '../../../../core/loading-spinner/loading-spinner.component';
import { IncidentListExpandableComponent } from '../incident-list-expandable/incident-list-expandable.component';
import { IncidentListStateService } from '../incident-list.state.service';
import { AsyncPipe, CommonModule } from '@angular/common';

@Component({
  selector: 'adm-incident-list',
  templateUrl: './incident-list.component.html',
  styleUrls: ['./incident-list.component.scss'],
  imports: [LoadingSpinnerComponent, IncidentListExpandableComponent, MatPaginatorModule, MatSortModule, AsyncPipe, CommonModule],
})
export class IncidentListComponent {
  appState = inject(AppState);
  state = inject(IncidentListStateService);

  onPageChanged(event: PageEvent) {
    this.state.filters.update(x => ({
      ...x,
      page: event,
    }));
  }

  public sortData(sort: Sort) {
    this.state.filters.update(x => ({
      ...x,
      sort: sort,
      page: { ...x.page, pageIndex: 0 },
    }));
  }
}
